import { configureStore } from "@reduxjs/toolkit";
import { topic } from "./index";
import { user } from "./index";
import { category } from "./index";
import { availability } from "./index";
import { appointment } from "./index";
import { wallet } from "./index";
import { favorites } from "./index";
import { search } from "./index";
import { review } from "./index";

export const store = configureStore({
  reducer: {
    user: user.userReducer,
    activeTopics: topic.topicReducer,
    activeCategories: category.categoryReducer,
    availability: availability.availabilityReducer,
    appointments: appointment.appointmentReducer,
    wallet: wallet.walletReducer,
    favorites: favorites.favoritesReducer,
    search: search.searchReducer,
    review: review.reviewReducer,
  },
});
